export default "__VITE_ASSET__BsYlVgE4__"